import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        $state,
        AuthFactory,
        CompanyFactory,
        FormVerificationService,
        LocalStorageService
    ) {
        var vm = this;

        init();

        function init() {
            vm.login = login;
            checkUserGroupAndForwardHim();
        }

        function checkUserGroupAndForwardHim() {
            if (LocalStorageService.read('common/token')) {
                if (!LocalStorageService.getObject('common/user')) {
                    getCurrentUser();
                }
            } else {
                getCurrentUser();
            }
        }

        function getCurrentUser() {
            AuthFactory.readMe().then(
                function (response) {
                    LocalStorageService.saveObject(
                        'common/user',
                        response.data
                    );
                    switch (response.data.groups[0]) {
                        case 'CompanyEmployee':
                            getCompany();
                            break;
                        case 'HousingAssociationEmployee':
                            $state.go('housing_association.issue_list');
                            break;
                        default:
                            $state.go('admin');
                    }
                },
                function (response) {
                    if (response.status === 401) {
                        LocalStorageService.removeLocalData();
                    }
                }
            );
        }

        function login() {
            AuthFactory.authLoginMulti({
                username: vm.username,
                password: vm.password,
                remember_me: true,
            }).then(
                function (response) {
                    LocalStorageService.set(
                        'common/token',
                        'Bearer ' + response.data.key
                    );
                    checkUserGroupAndForwardHim();
                },
                function (error) {
                    if (error.status === 401) {
                        LocalStorageService.removeLocalData();
                        vm.login();
                    } else {
                        FormVerificationService.error(error.data, vm.form);
                    }
                }
            );
        }

        function getCompany() {
            CompanyFactory.readCompany().then(function (response) {
                LocalStorageService.saveObject('common/company', response.data);
                $state.go('company_employee.issue_list');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/login/login.controller.ts